// extracted by mini-css-extract-plugin
export default {"UASunsetDisclaimer":"c8G1dKtEPBK60oUObpjn","messageDisclaimer":"mg8_8wlOhOmbTZdD_8jX","newAdUserSunsetDisclaimer":"GeO6eUS4rzdSSXNnGESU"};